/**
 * Component to show the listing information for users
 */
import * as React from 'react';
import { Table, Modal, Row, Tooltip, Icon } from 'antd';
import { IcommonProps } from '../common/props';
import '../../css/UserList.scss';
import util from '../common/utils';
import { Link } from 'react-router-dom';
import strings from '../../eyeguide-localization/user/string.user';
import Token from '../common/token';
import { CustomSorter } from '../Sorter';
/**
 * Property definition 
 */
interface IUserListProps extends IcommonProps {
    users: Array<any>;
    notifyActiveClick: any;
    notifyResetClick: any;
    loading: boolean;
    emptyText: string;
    showAction: boolean;
    showOrg: boolean;
    showActiveCol: boolean;
}

/**
 * State definition
 */
interface IUserListState {
    columnData: Array<any>;
    columns: Array<any>;
    pagination: any;
    loading: boolean;
    selectedRowKeys: Array<string>;    
    childColumnNames: any;
    modalVisible: any;
    recordClicked: any;
    emptyText: string;
    loggedInUid: string;
}

/**
 * Listing component for displaying the users
 */
export default class UserList extends React.Component<IUserListProps, IUserListState> {

    rowClass: string = 'rows';

    constructor(props: IUserListProps) {
        super(props);
        this.state = {
            columnData: [],
            columns: [],
            pagination: {},
            loading: true,
            selectedRowKeys: [],
            childColumnNames: ['name', 'value'],
            modalVisible: false,
            recordClicked: [],
            emptyText: '',
            loggedInUid: Token.decodeToken().uid
        };        
    }

    componentDidMount() {
        this.componentWillReceiveProps(this.props);

    }

    componentWillReceiveProps(nextProps: any) {
        let columnData: any[] = this.buildData(nextProps.users);
        let columns = this.buildColumns(nextProps);
        const pagination = { ...this.state.pagination };
        pagination.total = nextProps.users.length;
        pagination.pageSize = 20 ;
        pagination.pageSizeOptions = ['20', '50', '75', '100'];
        pagination.showSizeChanger = true ;  
        pagination.showTotal = function (total: any) {
            return strings.formatString(strings.lsTotalUsrsTxt, total);
        };
        this.setState({
            loading: nextProps.loading,
            columnData: columnData,
            columns: columns,
            pagination,
            emptyText: nextProps.users.length === 0 ? 'No data' : ''
        });
    }

    render() {
        console.log('UserList render called');
        return (     
            <div>      
            <Table 
                className="UserList"
                columns={this.state.columns} 
                dataSource={this.state.columnData} 
                pagination={this.state.pagination}
                rowKey={record => record.uid}
                loading={this.state.loading}
                rowClassName={(record, index) => 'rows'}
                expandRowByClick={true}
                locale={{ emptyText: this.state.emptyText }} 
            />
                        <Modal 
                            className="modal"
                            title={strings.lsConfirmPassResetHdrTxt}
                            visible={this.state.modalVisible}
                            okText={strings.lsYesTxt}
                            onOk={() => this.setModalVisible(1)}
                            onCancel={() => this.setModalVisible(0)}
                            width={500}
                            bodyStyle={{padding: 0 }}
                            maskClosable={false}
                            closable={false}
                            destroyOnClose={true}
                        >   
                            <Row style={{padding: '19px'}}>
                                    { strings.lsConfirmPassResetTxt + ' ' + 
                                                this.state.recordClicked.username + ' ?' }
                            </Row>
                        </Modal>
            </div>
        );            
    }

    /**
     * This function builds the data required by the Table component to display the Users
     * @param users Users array containing the users to be dispalyed
     */
    private buildData(users: Array<any>) {
        
        let columnData: Array<any> = [];
        users.forEach( (element: any) => {
            console.log('build', element );
            let data = {
                uid: element.uid,
                username: element.username,
                firstname: element.firstname,
                lastname: element.lastname,
                email: element.email,
                role: util.getRoleValue(element.roleid),
                active: element.active === 1 ? strings.lsYesTxt : strings.lsNoTxt,
                organizations: this.props.showOrg ?
                    element.organizations.length > 1 ? 'Multiple'
                    : element.organizations.length ? element.organizations[0].name
                    : '' : '',
                    // this.getCommaSepList(element.organizations)
                setup: element.setup,
                signin: element.signin
            };
            columnData.push(data);
        }); 
        console.log('columnData', columnData);
        return columnData;
    }
  
    /**
     * This function returns the column setting for use with the Table component
     */
    private buildColumns(nextProps: any) {
        let user = this.state.loggedInUid;
        let onHeaderCell = (column) => {
            return {
                onClick: () => {
                    this.setState({
                        columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                    });
                }
            };
        };
        let columns: any = [
          {
            title: strings.lsUsrNameTxt,
            dataIndex: 'username',
            sorter: (a: any, b: any) => a.username.localeCompare(b.username),
            className: 'rows',
            onHeaderCell
          },
          {
            title: strings.lsFNameTxt,
            dataIndex: 'firstname',
            sorter: (a: any, b: any) => a.firstname.localeCompare(b.firstname),
            className: 'rows',
            onHeaderCell
          },
          {
            title: strings.lsLNameTxt,
            dataIndex: 'lastname',
            sorter: (a: any, b: any) => a.lastname.localeCompare(b.lastname),
            className: 'rows',
            onHeaderCell
          },
          this.props.showOrg ? {
            title: strings.lsOrgsTxt,
            dataIndex: 'organizations',
            sorter: (a: any, b: any) => a.organizations.localeCompare(b.organizations),
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    style={{width: '100px'}}
                    title={text}
                >
                {text}
                </div>),
            onHeaderCell
            } : {},
           {
            title: strings.lsEmailTxt,
            dataIndex: 'email',
            sorter: (a: any, b: any) => a.email.localeCompare(b.email),
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    style={{width: '100px'}}
                    title={text}
                >
                {text}
                </div>),
            onHeaderCell
          } ,
          {
            title: strings.lsRoleTxt,
            dataIndex: 'role',
            sorter: (a: any, b: any) => a.role.localeCompare(b.role),
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    style={{width: '100px'}}
                    title={text}
                >
                {text}
                </div>),
            onHeaderCell
          } ,
          this.props.showOrg ?
          {
            title: 'Setup',
            dataIndex: 'setup',
            sorter: (a: any, b: any) => a.setup - b.setup,
            className: 'rows',
            render: (text: any) => {
                return text ? <Icon type="check" style={{color: 'green'}} />
                    : <Icon type="close" style={{color: 'red'}} />;
            },
            onHeaderCell
          } : {},
          this.props.showOrg ?
          {
            title: 'Sign In',
            dataIndex: 'signin',
            sorter: (a: any, b: any) => a.signin - b.signin,
            className: 'rows',
            render: (text: any) => {
                return text ? <Icon type="check" style={{color: 'green'}} />
                    : <Icon type="close" style={{color: 'red'}} />;
            },
            onHeaderCell
          } : {}];

        // if Device is mobile phone or tablet then remove email column.
        if (screen.width <= 1280) {
            for (let i = 0; i < columns.length; i++) {
                if (columns[i].dataIndex === 'email') {
                    columns.splice(i, 1);
                    break;
                }
            }
        }
        if (this.props.showActiveCol) {
            columns.push({
                title: strings.lsActiveTxt,
                dataIndex: 'active',
                className: 'rows',
                sorter: (a: any, b: any) => a.active.localeCompare(b.active),
                onHeaderCell
            });
        }
        if (this.props.showAction) {
            columns.push({
            title: strings.lsActionTxt,
            dataIndex: 'uid',            
            render: (text: any, record: any) => (
                <div style={{wordBreak: 'normal'}}>
                    <Link 
                        // className="linkSpacing"
                        to={'/user/view/' + record.uid}
                    >{record.uid !==  user ? strings.lsView + ' | ' : strings.lsView}
                    </Link>
                        {record.uid !==  user ?
                    <Link 
                        // className="linkSpacing"
                        to={'/user/edit/' + record.uid}
                    >{strings.lsEditTxt + ' | '}
                    </Link>
                        : ''}
                    {record.uid !==  user ? 
                    <a 
                        // className="linkSpacing"
                        onClick={ (e) => {    
                            console.log('e in onclick', record);  
                            e.stopPropagation();               
                            this.props.notifyActiveClick(record.active === 'No' ? 1 : 0, record.uid, record); }
                        }
                        
                    >{record.active === 'No' ? strings.lsActivateTxt + ' | ' 
                                    : strings.lsDeActivateTxt + ' | '}
                    </a> : ''}
                    {record.uid !==  user ?
                    <Tooltip placement="rightBottom" title={strings.lsCanResetTxt}>
                    <a 
                        onClick={ (e) => {    
                                console.log('e in onlcick', record);  
                                e.stopPropagation();       
                                this.setState({
                                    modalVisible: true,
                                    recordClicked: record
                                });    
                            }
                        }
                    >{strings.lsResetTxt}
                    </a>
                    </Tooltip> : ''}
                </div>
                )
            });
          }
        return columns;
    }

    // private getCommaSepList(orgs: any) {
    //     let valString: string = '';
    //     if (orgs !== undefined) {
    //     for (let j = 0; j < orgs.length; j++) {
    //         j === orgs.length - 1 ? valString += orgs[j].name : valString += orgs[j].name + ', ';
    //     }
    //     }
    //     return valString;
    // }

    private confirmResetPwd() {
        let record = this.state.recordClicked;
        this.props.notifyResetClick(record.uid, record.firstname, record.username);
    }

    private setModalVisible(event: any) {
        console.log();
        if (event === 1) {
            this.confirmResetPwd();
        } 
        this.setState({
            modalVisible: false
        });
    }

}


// WEBPACK FOOTER //
// ./src/components/user/UserList.tsx